<script setup>
import { swalError, generateGradient, getLowerAge } from '@/helper';
import { age_distribution } from '@/services/child';
import { onMounted, ref } from 'vue';
import { pieChart } from '@/data/dashboard/apexChart';
import { get_age_group_ass } from '@/services/assessments';
import { get_term, get_terms } from '@/services/terms';


const isLoading = ref(true)
const age_group = ref()
const chart_config = ref({})
onMounted(async()=>{
  await get_age_dist()
  await parse_age_group()
  let result = assignDistributionToTerms(age_group.value, age_dist.value.data.distribution);
  chart_config.value.data = result
  generateChart()
  isLoading.value = false
})

async function parse_age_group(){
  let response = await get_terms('age_group')
  if (response.error){
    swalError(response.result, true)
    return
  }
  age_group.value = sortAgeGroup(response.result.data.data)
}

function sortAgeGroup(response){
  response.sort((a, b) => getLowerAge(a.attributes.name) - getLowerAge(b.attributes.name));
  return response
}

function parseTerms(terms) {
  return terms.map(term => {
    let [min, max] = term.attributes.name.match(/\d+/g).map(Number);
    return { min, max, term, count: 0 };
  });
}

// Assign distribution to age ranges
function assignDistributionToTerms(terms, distribution) {
  let parsedTerms = parseTerms(terms);
  
  for (let age in distribution) {
    let count = distribution[age];
    let ageNumber = parseInt(age);
    
    for (let range of parsedTerms) {
      if (ageNumber >= range.min && ageNumber <= range.max) {
        range.count += count;
      }
    }
  }
  
  return parsedTerms.map(range => ({ term: range.term, count: range.count }));
}


const age_dist = ref({})
async function get_age_dist(){
  let response = await age_distribution()
  if (response.error){
    swalError(response.error, true)
    return
  }
  age_dist.value = parseAge(response.result.data)
}

function parseAge(data){
  let ageList = Object.keys(data.distribution).map(age => `${age} yrs`);
  let valueList = Object.values(data.distribution);
  return {
    data,
    ageList,
    valueList,
  }
}

function generateChart(){
  chart_config.value.chartOptions = pieChart
  chart_config.value.chartOptions.labels = chart_config.value.data.map(item => item.term.attributes.name)
  chart_config.value.series = chart_config.value.data.map(item => item.count)
  let mainColorHex = "#7366ff"; 
  let endColorHex = "#9BE8D8"; 
  chart_config.value.chartOptions.colors = generateGradient(mainColorHex, endColorHex, chart_config.value.series.length);
}
</script>

<template>
  <div class="card progress-report">
    <div class="card-header py-3">
      <h5>Child Age Distribution</h5>
    </div>
    <div class="card-body" v-if="!isLoading">
      <apexchart height="200" 
        type="donut" 
        :options="chart_config.chartOptions" 
        :series="chart_config.series"
      ></apexchart>
    </div>    
  </div>
</template>

  